<template>

    <v-button class="identifier" size="xs" btn-style="white" @click.native="copyText">
        <span class="label" :title="uuid" ref="textToCopy">{{ uuid }}</span>
        <i v-if="!copied" class="fas fa-clipboard ml-5"></i>
        <i v-else class="fas fa-clipboard-check ml-5 text-success"></i>
    </v-button>

</template>

<style lang="scss">

    .identifier {
        > span {
            align-items: center;
            display: flex;
            justify-content: space-between;
        }
        .label {
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            user-select: text;
            white-space: nowrap;
            width: 60px;
        }
    }

</style>

<script>

export default {

    props: {
        uuid: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            copied: false,
        }
    },

    methods: {

        copyText() {
            navigator.clipboard.writeText(this.uuid)
                .then(() => {
                    this.$store.commit('setAlertSuccess', this.$t('message.copiedId'));
                    this.copied = true;
                })
                .catch(() => {
                    this.$store.commit('setAlertError', 'Unable to copy text.');
                });
        },

    },

}

</script>
